module.exports = __webpack_public_path__ + "static/carpool-gallery-4-4e78beb70a1b2ca020b3d9cba13d0f2e.jpg";